import * as Sentry from '@sentry/react';
import { useCallback } from 'react';

type Submitter = HTMLButtonElement | HTMLInputElement;

function polyfillRequestSubmit(form: HTMLFormElement, submitter?: Submitter) {
  try {
    if (submitter) {
      submitter.click();
    } else {
      const tmp = document.createElement('button');
      tmp.type = 'submit';
      tmp.style.display = 'none';
      form.appendChild(tmp);
      tmp.click();
      form.removeChild(tmp);
    }
  } catch (e) {
    Sentry.captureException(new Error('Error in requestSubmit-polyfill'), {
      tags: { section: 'requestSubmit-polyfill' },
      extra: {
        error: e,
        formInfo: form
          ? {
              id: form.id,
              className: form.className,
              method: form.method,
              action: form.action,
            }
          : 'formRef is null',
      },
    });
  }
}

export function useRequestSubmit(formRef: React.RefObject<HTMLFormElement>) {
  return useCallback(
    (submitter?: Submitter) => {
      const form = formRef.current;
      if (!form) return;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else {
        polyfillRequestSubmit(form, submitter);
      }
    },
    [formRef],
  );
}
